// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0px 1000px white inset;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #555 !important;
}

.btn-enviar {
  margin-top: 20px;
}

h3 {
  text-align: center;
}

.panel {
  border: none;
  box-shadow: none;
}

.navegacao {
  text-align: center;
  margin-top: 40px;
}
.navegacao .ponto {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #cccccc;
  margin: 0 5px;
  cursor: pointer;
}
.navegacao .ponto.ativo {
  background-color: #22b7ff;
}

.btn-invertido {
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 1.8rem;
  padding: 10px 30px;
  border-radius: 5px;
  letter-spacing: 0.8px;
  font-weight: bolder;
  color: #999999;
}
.btn-invertido:active, .btn-invertido:hover, .btn-invertido:focus {
  box-shadow: none !important;
  text-decoration: underline;
}

.secoes {
  overflow: hidden;
  padding: 0px;
}

.secao {
  position: relative;
}

.btns {
  position: relative;
  width: 100%;
  height: 40px;
}

.btn-back {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}

.btn-next {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}

.finished .icone {
  width: 140px;
  height: 140px;
  background-image: none;
}
.finished h3 {
  margin: 20px 0px 0px 0px;
}

.icone.not-animated {
  opacity: 1;
}

@keyframes dash-stroke-1 {
  0% {
    stroke-dasharray: 0, 500;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 500, 500;
    opacity: 1;
  }
}
.finished .icone .path-1 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-1 4s ease-out forwards 0.75s;
}
@keyframes dash-stroke-2 {
  0% {
    stroke-dasharray: 0, 500;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 500, 500;
    opacity: 1;
  }
}
.finished .icone .path-2 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-2 3s ease-out forwards 1s;
}

.icone-sucesso {
  margin: 40px 0;
}

.adquirente select {
  padding: 0 0 0 70px;
}

select {
  width: 100%;
  outline: none;
  padding: 0 10px 0 10px;
  border: solid 2px #e2e2e2;
  background-image: url("/assets/img/arrow-down.png");
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 6px;
}

.ui-select {
  width: 100%;
}

/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}

select {
  appearance: none;
}

@-moz-document url-prefix() {
  .ui-select {
    border: 1px solid #CCC;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
  .ui-select select {
    width: 110%;
    background-position: right 30px center !important;
    border: none !important;
  }
}
.dropdown-toggle,
.dropdown-menu {
  width: 300px;
}
.dropdown-toggle.uf,
.dropdown-menu.uf {
  height: 200px;
  overflow-y: scroll;
}

.btn-group img {
  float: left;
  margin-top: 0px;
  height: 15px;
}

.btn-group span {
  float: right;
  margin-right: 0px;
  height: 15px;
}

.dropdown-toggle {
  padding-right: 50px;
}

.dropdown-toggle .glyphicon {
  margin-left: 20px;
  margin-right: -40px;
}

.dropdown-header {
  background: #ccc;
  font-size: 14px;
  font-weight: 700;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.adquirente img {
  position: absolute;
  top: 31px;
  left: 50%;
  transform: translatex(-59%);
  width: 62px;
}

.btn-outline,
.btn-outline:active {
  color: #6a5cff;
  background: #f7f7f7;
  font-weight: bolder;
  box-shadow: inset 0px 0px 0px 2px #6a5cff !important;
}

.grupo-1,
.grupo-2,
.grupo-3 {
  opacity: 0;
  transition: all 0.5s ease;
}

.secao-ativa-4 {
  background: #f7f7f7;
  opacity: 0;
  height: 0;
}

.secao-ativa-4 svg {
  opacity: 0;
}

.secao-ativa-1 .grupo-1,
.secao-ativa-2 .grupo-2,
.secao-ativa-3 .grupo-3 {
  animation: animacao-direita-esquerda 0.75 forwards 0.5s;
  transform: translateX(-500px);
  transition: all 0.5s ease;
}

.fade-in-left {
  animation: fade-in-left 0.75s;
  transition: all 0.75 ease;
}

.fade-out-left {
  animation: fade-out-left 0.75s;
  transition: all 0.75 ease;
}

.fade-in-right {
  transform: translateX(500px);
  animation: fade-in-right 0.75s;
  transition: all 0.75 ease;
}

.fade-out-right {
  animation: fade-out-right 0.75s;
  transition: all 0.75 ease;
}

@keyframes animacao-direita-esquerda {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(-4px);
  }
}
@keyframes fade-out-left {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-500px);
  }
}
@keyframes fade-in-left {
  0% {
    opacity: 0;
    transform: translateX(-500px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fade-out-right {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(500px);
  }
}
@keyframes fade-in-right {
  0% {
    opacity: 0;
    transform: translateX(500px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.tipo-pessoa {
  width: 200px;
  float: left;
}
.tipo-pessoa > div {
  float: left;
  width: 200px;
}
.tipo-pessoa input {
  height: auto;
}
.tipo-pessoa label {
  margin-left: 10px;
}

form button {
  margin: 40px 0px;
}

.tipo-de-pessoa {
  margin-bottom: 20px;
  text-align: center;
}
.tipo-de-pessoa button {
  padding: 6px 12px;
  border: solid 2px #e2e2e2;
  color: #e2e2e2;
  background-color: #fff;
  border-radius: 4px;
}
.tipo-de-pessoa button.active {
  border: solid 2px #00caff;
  color: #00caff;
}

.btn-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.input-link {
  color: #999999;
  position: absolute;
  top: 26px;
  right: 10px;
  padding: 8px 20px;
  font-size: 12px;
  background-color: #eee;
  cursor: pointer;
}

.dropdown button {
  width: 100%;
  text-align: left;
  margin: 0;
  background-color: #fff;
  border: 1px solid #e2e2e2;
  box-shadow: none;
  font-size: 13px;
  padding-left: 12px;
}
.dropdown button .caret {
  position: absolute;
  top: 18px;
  right: 12px;
}
.dropdown button:focus {
  border-color: #00bcd4;
}

.btn:not(.disabled):not(:disabled):active, .btn:not(.disabled):not(:disabled).active {
  box-shadow: none;
}

.btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open > .dropdown-toggle.btn-default.focus, .open > .dropdown-toggle.btn-default:focus, .open > .dropdown-toggle.btn-default:hover {
  background-color: #fff;
}

.file {
  display: none;
}

.input {
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 1px dashed #e2e2e2;
  border-radius: 6px;
  line-height: 38px;
  padding-left: 15px;
  transition: 0.5s;
  cursor: pointer;
}
.input:hover {
  border: 1px dashed #00f6ff;
  transition: 0.5s;
}
.input.disabled {
  color: #e2e2e2;
  background-color: rgba(255, 255, 255, 0.7);
  border: 1px dashed #e2e2e2;
}
.input.disabled:hover {
  border: 1px dashed #e2e2e2;
}

.icon-camera {
  margin-top: 35px;
}
.icon-camera i {
  cursor: pointer;
  font-size: 17px;
}
.icon-camera i.disabled {
  color: #ddd;
  cursor: default;
}

#resultado-sucesso {
  float: none;
}

#resultado-sucesso h3 {
  display: block;
  color: #00caff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  margin-top: 8px;
  margin-bottom: 40px;
  font-size: 18px;
}

#resultado-reprovado h3 {
  display: block;
  color: #e95753;
  margin-top: 8px;
  font-family: "Pague.la", "Open Sans", sans-serif;
}

#resultado-reprovado svg {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.erro-reprovacao {
  text-align: center;
}

/*altura SVGS de validação*/
#resultado-sucesso svg,
#resultado-reprovado svg {
  height: 75px;
}

/*animação círculos svgs*/
#resultado-sucesso svg circle,
#resultado-reprovado svg circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2.5s ease forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
/* animação somente de sucesso */
#resultado-sucesso svg polyline {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3.5s ease forwards;
  animation-delay: 0.25s;
}

#resultado-reprovado svg .linha-1 {
  transform: translate(20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.3s;
}

#resultado-reprovado svg .linha-2 {
  transform: translate(-20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.4s;
}

@keyframes entrando {
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
/* animação reprovado */
#resultado-reprovado svg {
  animation: shake-reprovado 0.35s ease forwards;
  animation-delay: 0.6s;
}

@keyframes shake-reprovado {
  10%, 90% {
    transform: translate3d(0, -1px, 0);
  }
  20%, 80% {
    transform: translate3d(0, 2px, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(0, -4px, 0);
  }
  40%, 60% {
    transform: translate3d(0, 4px, 0);
  }
}
#resultado-sucesso .bandeira-cartao {
  position: absolute;
  top: -5px;
  right: 0px;
}

#resultado-sucesso .info-cartao {
  position: relative;
  padding-right: 75px;
}

#resultado-sucesso .fechar {
  margin-top: 40px;
}

#resultado-sucesso svg {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

#resultado-sucesso .info-transacao-aprovada {
  margin-top: 20px;
}

#resultado-sucesso .info-transacao-aprovada hr {
  margin: 10px 0 !important;
}

#resultado-sucesso .dados-aprovados {
  display: flex;
  justify-content: space-between;
}

.text-implantacao {
  text-align: center;
  margin-bottom: 40px;
}

.bancos-dropdown {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 200px;
}
.bancos-dropdown li {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/register/register.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;;;;EAIE,sCAAA;EACA,8CAAA;EACA,yDAAA;EAAA,iDAAA;EACA,wCAAA;AAAF;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;AAAF;AACE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBCdQ;EDeR,aAAA;EACA,eAAA;AACJ;AAAI;EACI,yBC7BG;AD+BX;;AAGA;EACI,gDAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cC/BQ;AD+BZ;AACI;EAGE,2BAAA;EACA,0BAAA;AADN;;AAKA;EACI,gBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAFJ;;AAMI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AAHR;AAKI;EACI,wBAAA;AAHR;;AAOA;EACI,UAAA;AAJJ;;AASQ;EACI;IACI,wBAAA;EANd;EAQU;IACI,UAAA;EANd;EAQU;IACI,0BAAA;IACA,UAAA;EANd;AACF;AAQQ;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,mDAAA;AANZ;AAQQ;EACI;IACI,wBAAA;EANd;EAQU;IACI,UAAA;EANd;EAQU;IACI,0BAAA;IACA,UAAA;EANd;AACF;AAQQ;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,gDAAA;AANZ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA,wDAAA;AAEA;EACI,aAAA;AATJ;;AAYA;EAEI,gBAAA;AATJ;;AAYA;EACI;IACI,sBAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;EATN;EAWE;IACI,WAAA;IACA,iDAAA;IACA,uBAAA;EATN;AACF;AAYA;;EAEI,YAAA;AAVJ;AAYI;;EACE,aAAA;EACA,kBAAA;AATN;;AAaA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAVJ;;AAaA;EACI,YAAA;EACA,iBAAA;EACA,YAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,iBAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAVJ;;AAaA;;EAEI,cC7OM;ED8ON,mBChOgB;EDiOhB,mBAAA;EACA,oDAAA;AAVJ;;AAaA;;;EAGI,UAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,mBC7OgB;ED8OhB,UAAA;EACA,SAAA;AAVJ;;AAaA;EACI,UAAA;AAVJ;;AAaA;;;EAGI,uDAAA;EACA,6BAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,6BAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,8BAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,4BAAA;EACA,8BAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,+BAAA;EACA,yBAAA;AAVJ;;AAaA;EACI;IACI,UAAA;IACA,4BAAA;EAVN;EAYE;IACI,UAAA;IACA,2BAAA;EAVN;AACF;AAaA;EACI;IACI,UAAA;IACA,wBAAA;EAXN;EAaE;IACI,UAAA;IACA,6BAAA;EAXN;AACF;AAcA;EACI;IACI,UAAA;IACA,6BAAA;EAZN;EAcE;IACI,UAAA;IACA,wBAAA;EAZN;AACF;AAeA;EACI;IACI,UAAA;IACA,wBAAA;EAbN;EAeE;IACI,UAAA;IACA,4BAAA;EAbN;AACF;AAgBA;EACI;IACI,UAAA;IACA,4BAAA;EAdN;EAgBE;IACI,UAAA;IACA,wBAAA;EAdN;AACF;AAiBA;EACE,YAAA;EACA,WAAA;AAfF;AAgBE;EACE,WAAA;EACA,YAAA;AAdJ;AAgBE;EACE,YAAA;AAdJ;AAgBE;EACE,iBAAA;AAdJ;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,kBAAA;AAfF;AAgBE;EACE,iBAAA;EACA,yBAAA;EACA,cCvWQ;EDwWR,sBAAA;EACA,kBAAA;AAdJ;AAeI;EACE,yBAAA;EACA,cAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,cCzXU;ED0XV,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,sBChYM;EDiYN,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAfF;AAgBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAdJ;AAgBE;EACE,qBAAA;AAdJ;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,sBCpZM;ADqYR;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;AAfF;AAgBE;EACE,0BAAA;EAEA,gBAAA;AAdJ;AAgBE;EACE,cCjbQ;EDkbR,0CAAA;EACA,0BAAA;AAdJ;AAeI;EACE,0BAAA;AAbN;;AAkBA;EACE,gBAAA;AAfF;AAgBE;EACE,eAAA;EACA,eAAA;AAdJ;AAeI;EACE,WAAA;EACA,eAAA;AAbN;;AAkBA;EACE,WAAA;AAfF;;AAkBA;EACE,cAAA;EACA,cAAA;EACA,gDCzbe;ED0bf,eAAA;EACA,mBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gDCnce;ADobjB;;AAkBA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA,2BAAA;AAEA;;EAEE,YAAA;AAhBF;;AAmBA,yBAAA;AAEA;;EAEE,sBAAA;EACA,uBAAA;EACA,kCAAA;AAjBF;;AAoBA;EACE;IACE,oBAAA;EAjBF;AACF;AAoBA,gCAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,iCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,kCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE;IACE,8BAAA;IACA,UAAA;EAnBF;AACF;AAsBA,uBAAA;AAEA;EACE,8CAAA;EACA,qBAAA;AArBF;;AAwBA;EACE;IAEE,kCAAA;EAtBF;EAwBA;IAEE,iCAAA;EAvBF;EAyBA;IAGE,kCAAA;EAzBF;EA2BA;IAEE,iCAAA;EA1BF;AACF;AA6BA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,8BAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;AA3BF;AA6BE;EACE,eAAA;AA3BJ","sourcesContent":["@import '../../../../sass/variables';\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  box-shadow: 0 0 0px 1000px white inset;\n  -webkit-box-shadow: 0 0 0px 1000px white inset;\n  transition: background-color 5000s ease-in-out 0s;\n  -webkit-text-fill-color: #555 !important;\n}\n\n.btn-enviar {\n    margin-top: 20px;\n}\n\nh3 {\n  text-align: center;\n}\n\n.panel {\n  border: none;\n  box-shadow: none;\n}\n\n.navegacao {\n  text-align: center;\n  margin-top: 40px;\n  .ponto {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 100%;\n    background-color: $cinza-400;\n    margin: 0 5px;\n    cursor: pointer;\n    &.ativo {\n        background-color: $azul-400;\n    }\n  }\n}\n\n.btn-invertido {\n    font-family: \"Pague.la\", \"Open Sans\", sans-serif;\n    font-size: 1.8rem;\n    padding: 10px 30px;\n    border-radius: 5px;\n    letter-spacing: 0.8px;\n    font-weight: bolder;\n    color: $cinza-500;\n    &:active,\n    &:hover,\n    &:focus {\n      box-shadow: none !important;\n      text-decoration: underline;\n    }\n}\n\n.secoes {\n    overflow: hidden;\n    padding: 0px;\n}\n\n.secao {\n    position: relative;\n}\n\n.btns {\n    position: relative;\n    width: 100%;\n    height: 40px;\n}\n\n.btn-back {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n}\n\n.btn-next {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    text-align: center;\n}\n\n.finished {\n    .icone {\n        width: 140px;\n        height: 140px;\n        background-image: none;\n    }\n    h3 {\n        margin: 20px 0px 0px 0px;\n    }\n}\n\n.icone.not-animated {\n    opacity: 1;\n}\n\n.finished {\n    .icone {\n        @keyframes dash-stroke-1 {\n            0% {\n                stroke-dasharray: 0, 500;\n            }\n            5% {\n                opacity: 1;\n            }\n            100% {\n                stroke-dasharray: 500, 500;\n                opacity: 1;\n            }\n        }\n        .path-1 {\n            stroke-dasharray: 0;\n            stroke-dashoffset: 0;\n            opacity: 0;\n            animation: dash-stroke-1 4s ease-out forwards 0.75s;\n        }\n        @keyframes dash-stroke-2 {\n            0% {\n                stroke-dasharray: 0, 500;\n            }\n            5% {\n                opacity: 1;\n            }\n            100% {\n                stroke-dasharray: 500, 500;\n                opacity: 1;\n            }\n        }\n        .path-2 {\n            stroke-dasharray: 0;\n            stroke-dashoffset: 0;\n            opacity: 0;\n            animation: dash-stroke-2 3s ease-out forwards 1.0s;\n        }\n    }\n}\n\n.icone-sucesso {\n    margin: 40px 0;\n}\n\n.adquirente select {\n    padding: 0 0 0 70px;\n}\n\nselect {\n    width: 100%;\n    outline: none;\n    padding: 0 10px 0 10px;\n    border: solid 2px $cinza-300;\n    background-image: url(\"/assets/img/arrow-down.png\");\n    background-size: 30px;\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 10px);\n    background-position-y: 6px;\n}\n\n.ui-select {\n    width: 100%\n}\n\n/* This is to remove the arrow of select element in IE */\n\nselect::-ms-expand {\n    display: none;\n}\n\nselect {\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n@-moz-document url-prefix() {\n    .ui-select {\n        border: 1px solid #CCC;\n        border-radius: 4px;\n        box-sizing: border-box;\n        position: relative;\n        overflow: hidden;\n    }\n    .ui-select select {\n        width: 110%;\n        background-position: right 30px center !important;\n        border: none !important;\n    }\n}\n\n.dropdown-toggle,\n.dropdown-menu {\n    width: 300px;\n\n    &.uf {\n      height: 200px;\n      overflow-y: scroll;\n    }\n}\n\n.btn-group img {\n    float: left;\n    margin-top: 0px;\n    height: 15px;\n}\n\n.btn-group span {\n    float: right;\n    margin-right: 0px;\n    height: 15px;\n}\n\n.dropdown-toggle {\n    padding-right: 50px\n}\n\n.dropdown-toggle .glyphicon {\n    margin-left: 20px;\n    margin-right: -40px\n}\n\n.dropdown-header {\n    background: #ccc;\n    font-size: 14px;\n    font-weight: 700;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin-top: 10px;\n    margin-bottom: 5px\n}\n\n.adquirente img {\n    position: absolute;\n    top: 31px;\n    left: 50%;\n    transform: translatex(-59%);\n    width: 62px;\n}\n\n.btn-outline,\n.btn-outline:active {\n    color: $violeta;\n    background: $background-common;\n    font-weight: bolder;\n    box-shadow: inset 0px 0px 0px 2px #6a5cff !important;\n}\n\n.grupo-1,\n.grupo-2,\n.grupo-3 {\n    opacity: 0;\n    transition: all 0.5s ease;\n}\n\n.secao-ativa-4 {\n    background: $background-common;\n    opacity: 0;\n    height: 0;\n}\n\n.secao-ativa-4 svg {\n    opacity: 0;\n}\n\n.secao-ativa-1 .grupo-1,\n.secao-ativa-2 .grupo-2,\n.secao-ativa-3 .grupo-3 {\n    animation: animacao-direita-esquerda 0.75 forwards 0.5s;\n    transform: translateX(-500px);\n    transition: all 0.5s ease;\n}\n\n.fade-in-left {\n    animation: fade-in-left 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-out-left {\n    animation: fade-out-left 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-in-right {\n    transform: translateX(500px);\n    animation: fade-in-right 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-out-right {\n    animation: fade-out-right 0.75s;\n    transition: all 0.75 ease;\n}\n\n@keyframes animacao-direita-esquerda {\n    0% {\n        opacity: 0;\n        transform: translateX(100px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(-4px);\n    }\n}\n\n@keyframes fade-out-left {\n    0% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateX(-500px);\n    }\n}\n\n@keyframes fade-in-left {\n    0% {\n        opacity: 0;\n        transform: translateX(-500px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes fade-out-right {\n    0% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateX(500px);\n    }\n}\n\n@keyframes fade-in-right {\n    0% {\n        opacity: 0;\n        transform: translateX(500px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.tipo-pessoa {\n  width: 200px;\n  float: left;\n  > div {\n    float: left;\n    width: 200px;\n  }\n  input {\n    height: auto;\n  }\n  label {\n    margin-left: 10px;\n  }\n}\n\nform button {\n  margin: 40px 0px;\n}\n\n.tipo-de-pessoa {\n  margin-bottom: 20px;\n  text-align: center;\n  button {\n    padding: 6px 12px;\n    border: solid 2px $cinza-300;\n    color: $cinza-300;\n    background-color: #fff;\n    border-radius: 4px;\n    &.active {\n      border: solid 2px #00caff;\n      color: #00caff\n    }\n  }\n}\n\n.btn-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.input-link {\n  color: $cinza-500;\n  position: absolute;\n  top: 26px;\n  right: 10px;\n  padding: 8px 20px;\n  font-size: 12px;\n  background-color: #eee;\n  cursor: pointer;\n}\n\n.dropdown button {\n  width: 100%;\n  text-align: left;\n  margin: 0;\n  background-color: $white;\n  border: 1px solid #e2e2e2;\n  box-shadow: none;\n  font-size: 13px;\n  padding-left: 12px;\n  .caret {\n    position: absolute;\n    top: 18px;\n    right: 12px;\n  }\n  &:focus {\n    border-color: #00bcd4;\n  }\n}\n\n.btn:not(.disabled):not(:disabled):active, .btn:not(.disabled):not(:disabled).active {\n  box-shadow: none;\n}\n\n.btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open>.dropdown-toggle.btn-default.focus, .open>.dropdown-toggle.btn-default:focus, .open>.dropdown-toggle.btn-default:hover {\n  background-color: $white;\n}\n\n.file {\n  display: none;\n}\n\n.input {\n  width: 100%;\n  height: 40px;\n  background-color: #fff;\n  border: 1px dashed #e2e2e2;\n  border-radius: 6px;\n  line-height: 38px;\n  padding-left: 15px;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  cursor: pointer;\n  &:hover {\n    border: 1px dashed #00f6ff;\n    -webkit-transition: 0.5s;\n    transition: 0.5s;\n  }\n  &.disabled {\n    color: $cinza-300;\n    background-color: rgba($white, 0.7);\n    border: 1px dashed #e2e2e2;\n    &:hover {\n      border: 1px dashed #e2e2e2;\n    }\n  }\n}\n\n.icon-camera {\n  margin-top: 35px;\n  i {\n    cursor: pointer;\n    font-size: 17px;\n    &.disabled {\n      color: #ddd;\n      cursor: default;\n    }\n  }\n}\n\n#resultado-sucesso {\n  float: none;\n}\n\n#resultado-sucesso h3 {\n  display: block;\n  color: #00caff;\n  font-family: $fonte-pague-la;\n  margin-top: 8px;\n  margin-bottom: 40px;\n  font-size: 18px;\n}\n\n#resultado-reprovado h3 {\n  display: block;\n  color: #e95753;\n  margin-top: 8px;\n  font-family: $fonte-pague-la;\n}\n\n#resultado-reprovado svg {\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.erro-reprovacao {\n  text-align: center;\n}\n\n/*altura SVGS de validação*/\n\n#resultado-sucesso svg,\n#resultado-reprovado svg {\n  height: 75px;\n}\n\n/*animação círculos svgs*/\n\n#resultado-sucesso svg circle,\n#resultado-reprovado svg circle {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 2.5s ease forwards;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* animação somente de sucesso */\n\n#resultado-sucesso svg polyline {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 3.5s ease forwards;\n  animation-delay: 0.25s;\n}\n\n#resultado-reprovado svg .linha-1 {\n  transform: translate(20px, -20px);\n  opacity: 0;\n  animation: entrando 0.25s ease-in forwards;\n  animation-delay: 0.3s;\n}\n\n#resultado-reprovado svg .linha-2 {\n  transform: translate(-20px, -20px);\n  opacity: 0;\n  animation: entrando 0.25s ease-in forwards;\n  animation-delay: 0.4s;\n}\n\n@keyframes entrando {\n  to {\n    transform: translate(0px, 0px);\n    opacity: 1;\n  }\n}\n\n/* animação reprovado */\n\n#resultado-reprovado svg {\n  animation: shake-reprovado 0.35s ease forwards;\n  animation-delay: 0.6s;\n}\n\n@keyframes shake-reprovado {\n  10%,\n  90% {\n    transform: translate3d( 0, -1px, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d( 0, 2px, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d( 0, -4px, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(0, 4px, 0);\n  }\n}\n\n#resultado-sucesso .bandeira-cartao {\n  position: absolute;\n  top: -5px;\n  right: 0px;\n}\n\n#resultado-sucesso .info-cartao {\n  position: relative;\n  padding-right: 75px;\n}\n\n#resultado-sucesso .fechar {\n  margin-top: 40px;\n}\n\n#resultado-sucesso svg {\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n#resultado-sucesso .info-transacao-aprovada {\n  margin-top: 20px;\n}\n\n#resultado-sucesso .info-transacao-aprovada hr {\n  margin: 10px 0 !important;\n}\n\n#resultado-sucesso .dados-aprovados {\n  display: flex;\n  justify-content: space-between;\n}\n\n.text-implantacao {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.bancos-dropdown {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 200px;\n\n  li {\n    cursor: pointer;\n  }\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
